import React, { useState, useEffect, useRef } from "react";

import { Scrollchor, easeOutQuad } from 'react-scrollchor';
import { ReactComponent as ActiveMenu } from '@assets/images/menu/active.svg';

import ActiveMenuPNG from '@assets/images/menu/active.png';

import { ReactComponent as IZLogo } from '@assets/images/header/iz-logo.svg';
import { ReactComponent as MenuClose } from '@assets/images/menu/menu-close.svg';

import { ReactComponent as Facebook } from '@assets/images/social/fb.svg';
import { ReactComponent as Twitter } from '@assets/images/social/tw.svg';
import { ReactComponent as VK } from '@assets/images/social/vk.svg';
import { ReactComponent as OK } from '@assets/images/social/ok.svg';
import { ReactComponent as Telegram } from '@assets/images/social/telegram.svg';

import { ReactComponent as NordStreamMobWhite2 } from '@assets/images/header/nord-stream-2-mob-white.svg';

import { ReactComponent as RectangleBlueMobile } from '@assets/images/menu/rectangle-blue-mobile.svg';
import { ReactComponent as RectangleBlueMobile1 } from '@assets/images/menu/rectangle-blue-mobile-1.svg';
import { ReactComponent as RectangleBlueMobile2 } from '@assets/images/menu/rectangle-blue-mobile-2.svg';

import { YandexShare } from '@ui/moleculs/atoms/YandexShare';

const menus = [
  { name: 'Главная', alias: 'main' },
  { name: 'Что такое <br />«Северный поток-2»', alias: 'what' },
  { name: 'Карта <br />«Северного потока-2»', alias: 'map' },
  { name: 'Основные этапы <br />строительства', alias: 'stage' },
  { name: 'Препоны и проблемы <br />реализации', alias: 'problem' },
  { name: 'Что даст газопровод <br />России и миру', alias: 'create' },
];

type PageMenuType = {
  onShowHeader: () => void;
  activeMenu: number;
  isDesktopOrLaptop?: any;
  onToggleMenu: () => void;
  open?: boolean;
};

export const PageMenu: React.FC<PageMenuType> = ({ ...props }) => {
  const { onShowHeader, activeMenu, isDesktopOrLaptop, onToggleMenu, open } = props;
  const [active, setActive] = useState(1);
  const [top, setTop] = useState(0);
  const [busy, setBusy] = useState(false);

  const toggleActive = (event: any) => {
    const target = event.target;
    const index = menus.findIndex(menu => menu.name.replace(/(<([^>]+)>)/gi, '') === target.textContent);
    const clickRing = document.querySelector('header[class*="-translate-y-0"] #click-ring') as HTMLElement;

    if (clickRing) {
      clickRing.click();
    }

    onToggleMenu();

    setActive(index);
    setTop(target.offsetTop);
    setBusy(true);
    const timer = setTimeout(() => {
      setBusy(false);
      clearTimeout(timer);
    }, 1500);
  };

  const menuRefs = [
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
    useRef<HTMLSpanElement>(null),
  ];

  const toggleShowHeader = () => {
    onShowHeader();
  };

  useEffect(() => {
    const target = menuRefs[activeMenu].current;
    if (!busy) {
      target && setTop(target.offsetTop);
    }
  }, [activeMenu, busy]);

  const menuLen = menus.length;

  return (
    <div
      style={{ backgroundImage: isDesktopOrLaptop? `none` : `none` }}
      className={`
        transform
        transition-all
        duration-500
        
        ${isDesktopOrLaptop? `
            top-2/4
            lg:max-w-115
            -translate-y-2/4
          `
          :
          `
            overflow-hidden
            bg-background-color-dark
            ${open ? `-translate-x-full` : ``}
            justify-between
            min-h-full
            bg-cover
            z-10
          `
        }

        flex
        flex-col
        fixed
        left-0
        
        w-full
        z-5
      `}
    >
      {isDesktopOrLaptop &&
        <div
          style={{ top }}
          className={`
            absolute
            top-0
            transition-all
            ease-in-out
            duration-500
            -ml-6
          `}
        >
          <img src={ActiveMenuPNG} width={161} height={26} alt="" />
          {/* <ActiveMenu /> */}
        </div>
      }
      {!isDesktopOrLaptop &&
        <>
          <div className={`flex justify-between`}>
            <a className="flex flex-col text-white hover:text-menu-number-active pl-4 py-5" href="https://iz.ru/">
              <IZLogo
                width={69}
                height={18}
                className="
                  fill-current
                "
              />
            </a>
            <span
              onClick={onToggleMenu}
              className={`flex text-white hover:text-menu-number-active shrink-0 cursor-pointer px-5 py-5`}
            >
              <MenuClose
                width={22}
                height={22}
                className="
                  pb-1.5
                  fill-current
                "
              />
            </span>
          </div>
          <div
            className={`
              relative
              text-white
              flex
              justify-center
              mt-16vw
            `}
          >
            <RectangleBlueMobile className={`absolute top-2/4 left-2/4 transform -translate-x-2/4 -translate-y-1/4`} />
            <RectangleBlueMobile1 className={`absolute left-2/4 transform -translate-x-4/5 -translate-y-0`} />
            <RectangleBlueMobile2 className={`absolute left-2/4 top-2/4 transform translate-y-1/3`} />
            <NordStreamMobWhite2
              className="
                fill-current
                relative
              "
            />
          </div>
        </>
      }
      <div
        className="
          relative
          text-white
          text-xs
          font-medium
          leading-5
          flex-1
          flex
          flex-col
          lg:block
          justify-center
        "
      >
        {menus.map((menu, idx) =>
          <span
            key={idx}
            ref={menuRefs[idx]}
            className={`
              flex
              lg:inline-flex
              justify-center
              cursor-pointer
              bg-no-repeat
              bg-right-top
              ${idx === 0 ? `lg:mb-7vh` : (idx === (menuLen - 1) ? `lg:mt-7vh` : `lg:my-7vh` )}
            `}
            onClick={toggleActive}
          >
            {idx === 0 ?
              <span
                onClick={toggleShowHeader}
                className={`
                  inline-flex
                  max-w-250
                  lg:max-w-none
                  ${idx === active ? `` : `hover:text-menu-number-active`}
                  text-center
                  lg:text-left
                  py-8vh
                  lg:pl-9vh
                  lg:pr-8
                  lg:pt-1
                  lg:pb-2
                `}
              >{menu.name}</span>
              :
              <Scrollchor
                key={idx}
                animate={{ duration: 1000, easing: easeOutQuad, offset: -124 }}
                className={`
                  inline-flex
                  max-w-250
                  py-8vh
                  ${idx === active ? `` : `hover:text-menu-number-active`}
                  text-center
                  lg:text-left
                  lg:max-w-none
                  lg:pl-9vh
                  lg:pr-8
                  lg:pt-1
                  lg:pb-2
                `}
                to={`#${menu.alias}`}
              >
                <span dangerouslySetInnerHTML={{ __html: menu.name }} />
              </Scrollchor>
            }
          </span>
        )}
      </div>
      {!isDesktopOrLaptop &&
        <div className={`flex justify-center px-5 py-5`}>
          <YandexShare id={`mobile`} color={`light`} />
          {/*
          <a
            className="transition text-white hover:text-menu-number-active mx-18vw my-4"
            target="_blank"
            rel="noreferrer"
            href="http://facebook.com/izvestia.ru"
          >
            <Facebook
              width={10}
              height={19}
              className="
                fill-current
              "
            />
          </a>
          <a
            className="transition text-white hover:text-menu-number-active mx-18vw my-4"
            target="_blank"
            rel="noreferrer"
            href="https://twitter.com/izvestia_ru"
          >
            <VK
              width={25}
              height={14}
              className="
                fill-current
              "
            />
          </a>
          <a
            className="transition text-white hover:text-menu-number-active mx-18vw my-4"
            target="_blank"
            rel="noreferrer"
            href="https://ok.ru/"
          >
            <OK
              width={25}
              height={14}
              className="
                fill-current
              "
            />
          </a>
          <a
            className="transition text-white hover:text-menu-number-active mx-18vw my-4"
            target="_blank"
            rel="noreferrer"
            href="https://vk.com/izvestia"
          >
            <Twitter
              width={20}
              height={16}
              className="
                fill-current
              "
            />
          </a>
          <a
            className="transition text-white hover:text-menu-number-active mx-18vw my-4"
            target="_blank"
            rel="noreferrer"
            href="https://web.telegram.org/z/"
          >
            <Telegram
              width={25}
              height={14}
              className="
                fill-current
              "
            />
          </a>
          */}
        </div>
      }
    </div>
  );
};